export default "__VITE_ASSET__CJxR6k7E__"